import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {default as templateStore} from "@/store";
import MainPageMobileVersion from "@/components/MainPage/MobileVersion.vue";
import MainPagePcVersion from "@/components/MainPage/PcVersion.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'MainPage',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(templateStore).state.pageSize.width > _unref(templateStore).state.mobileVersionThresholdWidth)
    ? (_openBlock(), _createBlock(MainPagePcVersion, { key: 0 }))
    : (_openBlock(), _createBlock(MainPageMobileVersion, { key: 1 }))
}
}

})